/*
 * Мак при нажатии дабл-пробела ставит точку и пробел, которая потом форматируется
 * в букву 'ю' (точка и 'ю' на одной клавише) в функции formatToRussian.
 * Поэтому заменяем просто на пробел
 */
export const replacePointSpaceToSpace = (value: string | number): string => {
    return String(value).replace('. ', ' ');
};
